import { Injectable } from "@angular/core";
import { AuctionBidQuery, AuctionBidService, AuctionQuery, AuctionService, LottoQuery, LottoService, LottoWalletQuery, LoyaltyStatusService, MarketplaceExtendedQuery, MarketplaceService, MixedLoyaltyItem, MixedLoyaltyItemType, MixedLoyaltyQuery, PurchaseQuery, PurchaseService } from "@fgb/core";
import { Observable } from "rxjs";

// @HACK: this is a hack to show only marketplace items and lottos item excluding auctions in the featured rewards component
@Injectable()
export class FeaturedRewardsCustomQuery extends MixedLoyaltyQuery{

    constructor(
      protected _auctionQuery: AuctionQuery,
      protected _marketplaceExtendedQuery: MarketplaceExtendedQuery,
      protected _lottoQuery: LottoQuery,
      protected _purchaseQuery: PurchaseQuery,
      protected _auctionBidQuery: AuctionBidQuery,
      protected _auctionBidService: AuctionBidService,
      protected _lottoWalletQuery: LottoWalletQuery,
      protected _auctionService: AuctionService,
      protected _lottoService: LottoService,
      protected _marketplaceService: MarketplaceService,
      protected _purchaseService: PurchaseService,
      protected _statusService: LoyaltyStatusService
    ){
        super(_auctionQuery, _marketplaceExtendedQuery, _lottoQuery, _purchaseQuery, _auctionBidQuery, _auctionBidService, _lottoWalletQuery, _auctionService, _lottoService, _marketplaceService, _purchaseService, _statusService);
    }
  
    override selectFavouriteMixedLoyaltyItems(
        showSoldOut: boolean = true,
        itemTypes: MixedLoyaltyItemType[] = [MixedLoyaltyItemType.Marketplace, MixedLoyaltyItemType.Lotto]
      ): Observable<MixedLoyaltyItem[]> {
        return super.selectFavouriteMixedLoyaltyItems(showSoldOut, itemTypes);
      }
}